<template>
  <div id="app">
    <router-link :to="toUrl"></router-link>
    <router-view/>
  </div>
</template>

<script>

export default {
  data() {
    return {
      toUrl: "/applyfor",
    }
  },
  created() {
    document.body.removeChild(document.getElementById("Loading"));
    this.loading = true
    this.toUrl =
      window.location.href.indexOf("applyfor") !== -1? "/applyfor" : "/reimburse";

        if (window.location.search.match(/id=([^&]+)/)) {
            localStorage.setItem("FlowId", window.location.search.match(/id=([^&]+)/)[1])
        } else {
            localStorage.removeItem('FlowId')
        }
        // 即使通信
        if (window.location.search.match(/platform=([^&]+)/)) {
            sessionStorage.setItem("platform", window.location.search.match(/platform=([^&]+)/)[1])
        } else {
            sessionStorage.removeItem('platform')
        }
        // 卡片feishucard pc+手机  审批feishuapprove pc+手机
        if (window.location.search.match(/doType=([^&]+)/)) {
            sessionStorage.setItem("doType", window.location.search.match(/doType=([^&]+)/)[1])
        } else {
            sessionStorage.removeItem('doType')
        }
        // deviceType  移动是mobile   pc是  pc
        if (window.location.search.match(/deviceType=([^&]+)/)) {
            sessionStorage.setItem("deviceType", window.location.search.match(/deviceType=([^&]+)/)[1])
        } else {
            sessionStorage.removeItem('deviceType')
        }
        if (window.location.search.match(/type=([^&]+)/)) {
            sessionStorage.setItem("markType", window.location.search.match(/type=([^&]+)/)[1])
        } else {
            sessionStorage.removeItem('markType')
        }
        if(window.location.search.match(/zhbg_tk=([^&]+)/)){
            // pc端获取token
            localStorage.setItem("rx_token", window.location.search.match(/zhbg_tk=([^&]+)/)[1]);
        }else{
            localStorage.removeItem('rx_token')
        }
    },
};
</script>

<style>
* {
  padding: 0 !important;
  margin: 0 !important;
}
a {
  text-decoration: none !important;
  color: black !important;
}
el-input {
  position: relative !important;
}
i {
  position: absolute !important;
  right: 25px !important;
  top: 23px !important;
}
.el-menu li {
  width: 50% !important;
  text-align: center !important;
  font-size: 18px !important;
}
th,
td {
  padding: 5px 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue